<template>
    <div class="box-content">
        <div class="box-content-inner">
            <h2 class="main-headline">YOUR PROJECT. YOUR VISION.</h2>
            <p class="subheadline">Fund Raisers, Ltd. has the products you need to reach the goals you want! We know<br/>
                too many options are overwhelming, so we have refined our product selection to <br/>
                ensure your project is successful.
            </p>
            <ul class="products-benefits-list">
                <li>
                    <img src="images/Products-Page/products1.png" alt="">
                    <h6 class="products-benefits-headline">HAND SELECTED</h6>
                    <span class="products-benefits-text">With 30+ years of experience,
                    we know what works.</span>
                </li>
                <li>
                    <img src="images/Products-Page/products2.png" alt="">
                    <h6 class="products-benefits-headline">TOP SELLER</h6>
                    <span class="products-benefits-text">Featured in thousands of projects in all 50 states.</span>
                </li>
                <li>
                    <img src="images/Products-Page/products3.png" alt="">
                    <h6 class="products-benefits-headline">QUALITY</h6>
                    <span class="products-benefits-text">We only use the best in the industry.</span>
                </li>
            </ul>
            <h6 class="products-selection-title">
                <div class="line"></div>
                <span>PRODUCT SELECTION</span>
                <div class="line"></div>
            </h6>
            <span class="products-selection-subtitle">Click on a product for more information</span>
            <ul class="products-selection-list">
                <li>
                    <router-link to="/bricks">
                        <img width="144" height="144" src="images/Products-Page/products4.png" alt="Bricks">
                    </router-link>
                    <router-link to="/bricks" class="product-icon">Bricks</router-link>
                </li>
                <li>
                    <router-link to="/tiles">
                        <img width="144" height="144" src="images/Products-Page/products5.png" alt="Tiles">
                    </router-link>
                    <router-link to="/tiles" class="product-icon">Tiles</router-link>
                </li>
                <li>
                    <router-link to="/fonts">
                        <img height="90" width="90" src="images/Products-Page/products6.png" alt="Fonts">
                    </router-link>
                    <router-link to="/fonts" class="product-icon">Fonts</router-link>
                </li>
                <li>
                    <router-link to="/symbols">
                        <img height="80" width="80" src="images/Products-Page/products7.png" alt="Symbols">
                    </router-link>
                    <router-link to="/symbols" class="product-icon">Symbols</router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script type="text/jsx">
    export default {
        name: 'products',
        metaInfo: {
            title: 'Products',
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: 'Fund Raisers, Ltd. has the products you need to reach the goals you want! Hand selected, quality bricks, tiles, fonts and symbols to ensure your success.'
                }
            ]
        }
    }
</script>




// WEBPACK FOOTER //
// Products.vue?5431ffb8